import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

export type InputProps = InputHTMLAttributes<HTMLInputElement>;

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, type = 'text', ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      type={type}
      className={cn(
        'block w-full',
        'h-11 px-3.5',
        'rounded-[var(--radius-md)]',
        'border border-[var(--color-border)]',
        'bg-[var(--color-surface)]',
        'text-[var(--color-ink)]',
        'placeholder:text-[var(--color-ink-subtle)]',
        'transition-shadow duration-[var(--duration-fast)] ease-[var(--ease-out-quart)]',
        'hover:border-[var(--color-border-strong)]',
        'aria-[invalid=true]:border-[var(--color-danger)]',
        'disabled:cursor-not-allowed disabled:opacity-60',
        'focus-visible:outline-none',
        className,
      )}
      {...rest}
    />
  );
});
